import React from 'react'
import styled from 'styled-components'
import { NolKoma7to1rem } from "../GlobalStyles";

const Wrapper = styled.div`
    background-color: black;
    height: 2rem;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (min-width: 700px) {
        height: 3rem;
    }
    @media (min-width: 800px) {
      display: grid;
      grid-template-columns: 0.7fr 1fr 0.7fr;
      padding: 0 1rem;
    }
    select {
      display: none;
      @media (min-width: 800px) {
        display: block;
        font-size: 0.8rem;
        outline: none;
        border: none;
        padding: 6px 12px;
        cursor: pointer;
        background-color: transparent;
        color: white;
      }
    }
`
const Text = styled.p`
    font-size: ${NolKoma7to1rem};
    @media (min-width: 800px) {
      justify-self: center;
    }
`
const Dreship = styled.div`
  display: none;
  @media (min-width: 800px) {
    color: white;
    display: flex;
    align-items: center;
    font-size: 12px;
    justify-self: end;
    p:not(:last-child) {
      margin-right: 10px;
    }
  }
`
const SelectWrap = styled.div`
  background-color: red;
  select {
    width: 70px;
    background-color: black;
    color: white;
    padding: 5px 0;
  }
  @media (min-width: 800px) {
    justify-self: start;
  }
`

export default function WelcomeMessage() {
  return (
    <Wrapper>
        <SelectWrap>
          <select name="choose" id="choose">
              <option value="myr">MYR</option>    
              <option value="sgd">SGD</option>    
              <option value="bnd">BND</option>    
          </select>
        </SelectWrap>
        <Text>Welcome to Hijabistahub Online Shop</Text>
        <Dreship>
          <p>Dropship Login</p>
          <p>/</p>
          <p>Register</p>
        </Dreship>
    </Wrapper>
  )
}
